import { render, staticRenderFns } from "./RelationAssignmentDialog.vue?vue&type=template&id=44ff92ff&"
import script from "./RelationAssignmentDialog.vue?vue&type=script&lang=js&"
export * from "./RelationAssignmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports